import { DisplayedCurrency } from '@coin/shared/core/util-enums';

export class SetEmployeeProfileCurrency {
  static readonly type = '[Employee Profile Currency] Set Currency';
  constructor(public readonly payload: DisplayedCurrency) {}
}
